// Web polyfill for @sentry/react-native
// On web, we can use @sentry/browser or provide no-op implementations
// This prevents build errors when Sentry is conditionally used

// Sentry no-op implementations for web
export const captureException = (error, context) => {
  // On web, you can integrate @sentry/browser if needed
  // For now, just log to console
  console.error('[Sentry]', error, context);
};

export const captureMessage = (message, level) => {
  console.log('[Sentry]', level, message);
};

export const setUser = (user) => {
  console.log('[Sentry] User set:', user);
};

export const setContext = (name, context) => {
  console.log('[Sentry] Context set:', name, context);
};

export const addBreadcrumb = (breadcrumb) => {
  console.log('[Sentry] Breadcrumb:', breadcrumb);
};

export const init = (options) => {
  console.log('[Sentry] Init called with options:', options);
  // On web, you could initialize @sentry/browser here if needed
};

// Default export
const SentryReactNative = {
  captureException,
  captureMessage,
  setUser,
  setContext,
  addBreadcrumb,
  init,
};

export default SentryReactNative;

